import { flatJoin } from 'shared/util'
import { KojinResult } from 'interface/kojin'

type ColumnDefsType = {
  label: string
  val: (kojin: KojinResult) => number | string | null | undefined
}
type ColumnDefsMap = {
  [index: string]: ColumnDefsType
}

export const ColumnDefs: ColumnDefsMap = {
  kojinCode: {
    label: '個人CD',
    val: (kojin) => kojin.kojinCode
  },
  personalId: {
    label: 'PersonalId',
    val: (kojin) => kojin.personalId
  },
  isiName: {
    label: '医師名',
    val: (kojin) => kojin.isiName
  },
  isiNameKana: {
    label: '医師名(カナ)',
    val: (kojin) => kojin.isiNameKana
  },
  eMail: {
    label: 'メールアドレス',
    val: (kojin) => kojin.eMail
  },
  eMailIfOk: {
    label: 'メールアドレス（許諾時のみ）',
    val: (kojin) => kojin.mailStatus === 'OK' ? kojin.eMail : undefined
  },
  seinenGappi: {
    label: '生年月日',
    val: (kojin) => kojin.seinenGappi
  },
  age: {
    label: '年齢',
    val: (kojin) => kojin.nenrei
  },
  seibetu: {
    label: '性別',
    val: (kojin) => kojin.seibetuCode === '1' ? '男性' : kojin.seibetuCode === '2' ? '女性' : '不明'
  },
  sisetu: {
    label: '現所属病院名',
    val: (kojin) => (kojin.organ?.map((organ) => flatJoin(' ', organ.sisetuName, organ.bukaName, organ.yakusyokuName)) ?? []).join('\r\n')
  },
  gakkai: {
    label: '現所属学会',
    val: (kojin) => (
      kojin.gakkai?.map((gakkai) => gakkai.gakkaiName) ?? []
    ).join('\r\n')
  },
  sinryoka: {
    label: '診療科',
    val: (kojin) => (
      kojin.sinryoka?.map((sinryoka) => sinryoka.sinryokaName) ?? []
    ).join('\r\n')
  },
  senmoni: {
    label: '専門医',
    val: (kojin) => (kojin.senmoni?.map((senmoni) => senmoni.senmoniName) ?? []).join('\r\n')
  },
  bedCount: {
    label: '病床数',
    val: (kojin) => kojin.organ?.reduce((max, organ) => Math.max(max, organ.bedCount ?? 0), 0)
  },
  sotukou: {
    label: '出身大学',
    val: (kojin) => kojin.sotukouName
  },
  sotugyouYear: {
    label: '卒業年',
    val: (kojin) => kojin.sotugyouYear
  },
  targetType: {
    label: '指定分類',
    val: (kojin) => kojin.target?.targetType?.name
  },
  cnUserType: {
    label: 'CN会員',
    val: (kojin) => (kojin.personalId ? '会員' : '非会員')
  },
  actorStats: {
    label: '出演歴',
    val: (kojin) => kojin.actor ? flatJoin('/',
      kojin.actor.isComActor ? 'COM' : null,
      kojin.actor.isTvActor ? 'TV' : null,
      kojin.actor.isDvdActor ? 'DVD' : null
    ) : null
  },
  picksExpert: {
    label: 'DoctorsPicks',
    val: (kojin) => kojin.picksExpert ? 'Expert' : null
  },
  mrpUserRank: {
    label: 'Tierランク',
    val: (kojin) => kojin.mrpStats?.rank?.name
  }
};
